/**
 * 데스크톱 목록 카드 호버 → 지도 핀 강조(09-29).
 *
 * 호버는 마우스가 카드 위를 지날 때마다 바뀐다. 이 값을 허브 state 에 두면 허브 전체
 * (수십 행 목록 포함)가 매번 다시 그려지므로, 작은 외부 저장소에 두고 **지도만**
 * `useSyncExternalStore` 로 구독한다. 목록 행은 `set` 만 부른다(구독하지 않는다).
 */
export interface StationHoverStore {
  get: () => string | null;
  set: (stationId: string | null) => void;
  subscribe: (listener: () => void) => () => void;
}

export function createStationHoverStore(): StationHoverStore {
  let current: string | null = null;
  const listeners = new Set<() => void>();
  return {
    get: () => current,
    set: (stationId) => {
      if (stationId === current) return;
      current = stationId;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
